// extracted by mini-css-extract-plugin
export default {"grid-loader":"grid-loader","gridLoader":"grid-loader","tile":"tile"};